import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import classNames from "classnames";
import dayjs from "dayjs";

import "dayjs/locale/vi";

dayjs.locale("vi");

export const NotificationContainer = forwardRef(
  ({ notifications, unreadNotifications }, ref) => {
    //#region Data
    const [open, setOpen] = useState(false);
    const [tab, setTab] = useState(0);
    const [viewAll, setViewAll] = useState(false);

    const modalRef = useRef(null);
    //#endregion

    //#region Event
    const onBackdropClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    //#endregion

    useImperativeHandle(ref, () => ({
      open: () => setOpen(true),
    }));

    //#region Render
    return (
      <div
        className={classNames(
          "fixed top-0 left-0 z-10 h-screen w-screen bg-[#1e1e1e12]",
          open ? "block" : "hidden"
        )}
        onClick={onBackdropClick}
      >
        <div
          ref={modalRef}
          className={classNames(
            "fixed !p-4 z-[11] w-[380px] bg-white rounded-xl shadow-lg right-[30px] top-[60px]"
          )}
        >
          <h6 className="text-2xl font-semibold leading-[22px]">Thông báo</h6>
          <div className="flex gap-2 !mt-3">
            <button
              className={classNames(
                "px-3 py-2 font-medium rounded-2xl outline-none shadow-none",
                tab === 0 ? "text-blue-600 bg-blue-100" : "text-black"
              )}
              onClick={() => setTab(0)}
            >
              Tất cả
            </button>
            <button
              className={classNames(
                "px-3 py-2 font-medium rounded-2xl outline-none shadow-none",
                tab === 1 ? "text-blue-600 bg-blue-100" : "text-black"
              )}
              onClick={() => setTab(1)}
            >
              Chưa đọc
            </button>
          </div>
          <div className="flex flex-col !mt-2 min-h-[500px] max-h-[600px] overflow-auto">
            {(tab === 0 ? notifications : unreadNotifications).map(
              (noti, index) => (
                <div
                  key={noti?.id + index}
                  className={classNames(
                    "px-2 py-1 rounded-xl w-full hover:bg-slate-100",
                    index < 5 || viewAll ? "block" : "hidden"
                  )}
                >
                  <p className="mb-0 font-medium">
                    {noti?.notification_content?.title}
                  </p>
                  <p className="mb-0">{noti?.notification_content?.body}</p>
                  <span className="text-xs text-blue-600 font-medium">
                    {dayjs(noti?.created_at).fromNow()}
                  </span>
                </div>
              )
            )}
          </div>
          {!viewAll && (
            <button
              onClick={() => setViewAll(true)}
              className="absolute whitespace-nowrap outline-none bottom-8 rounded-lg border-[1px_solid_rgb(0_0_0_/_4%)] px-3 py-2 bg-slate-200 font-semibold text-base z-[33] left-1/2 transform -translate-x-1/2"
            >
              Xem thông báo trước đó
            </button>
          )}
        </div>
      </div>
    );
    //#endregion
  }
);
